import * as Scrivito from "scrivito"
import { ScrivitoAttributes } from "shared/types/ScrivitoAttributes"

export const ProductBaseVariantObjClass = Scrivito.provideObjClass(
  "ProductBaseVariant",
  {
    attributes: {
      title: "string",
      titleShort: "string",
      descriptionShort: "string",
      image: ["reference", { only: "Image" }],
      imageWidgets: ["widgetlist", { only: "ImageWidget" }],
      description: "stringlist",
      productDescription: "stringlist",
      variantKey: "string",
      isHidden: "boolean"
    }
  }
)

export type ProductBaseVariantObj = InstanceType<
  typeof ProductBaseVariantObjClass
>
export type ProductBaseVariantAttributes =
  ScrivitoAttributes<ProductBaseVariantObj>
